// Context for the post-login redirect URL. Populated by the
// ``onRedirectCallback`` Kinde fires when the user lands back at
// ``/login-redirect`` after sign-in. ``LoginRedirect.tsx`` reads from
// it and navigates the user back to the page they were on before.
//
// Same shape as ``frontends/shared-components/auth/KindeRedirectContext.tsx``
// so anyone porting from admin-app finds familiar names.
import { createContext } from "react";

export interface KindeRedirectContextValue {
  redirectUrl: string | null;
  setRedirectUrl: (url: string | null) => void;
}

export const KindeRedirectContext = createContext<KindeRedirectContextValue>({
  redirectUrl: null,
  setRedirectUrl: () => {},
});
